export enum actionTypes {
    REQUEST_DOWNLOAD_SINGLE_ATTACHMENT = "request_download_single_attachment",
    RECEIVED_DOWNLOAD_SINGLE_ATTACHMENT = "received_download_single_attachment",
    COMPLETED_DOWNLOAD_SINGLE_ATTACHMENT = "completed_download_single_attachment",
    REQUEST_DOWNLOAD_ALL_ATTACHMENTS = "request_download_all_attachments",
    RECEIVED_DOWNLOAD_ALL_ATTACHMENTS = "received_download_all_attachments",
    COMPLETED_DOWNLOAD_ALL_ATTACHMENTS = "completed_download_all_attachments",
    REQUEST_DOWNLOAD_COMPANY_LOGO = "request_download_company_logo",
    RECEIVED_DOWNLOAD_COMPANY_LOGO = "received_download_company_logo",
    COMPLETED_DOWNLOAD_COMPANY_LOGO = "completed_download_company_logo"
}
